(() => {
  const wrapper = document.querySelector('.shulin-refinement .page-wrapper');
  const footer = wrapper?.querySelector(':scope > [data-shulin-footer-root]');
  const main = wrapper?.querySelector(':scope > #MainContent');

  if (!wrapper || !footer || !main) return;

  const desktop = window.matchMedia('(min-width: 990px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let updateFrame = 0;

  const update = () => {
    updateFrame = 0;
    const header = document.querySelector('#header-component');
    const headerAllowance = header?.hasAttribute('sticky')
      ? Math.ceil(header.getBoundingClientRect().height)
      : 0;
    const availableHeight = wrapper.clientHeight - headerAllowance - 24;
    const footerHeight = Math.ceil(footer.getBoundingClientRect().height);
    const canReveal = desktop.matches
      && !reducedMotion.matches
      && footerHeight > 0
      && footerHeight <= availableHeight;

    document.body.toggleAttribute('data-shulin-footer-reveal', canReveal);
  };

  const scheduleUpdate = () => {
    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(update);
  };

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(scheduleUpdate);
    observer.observe(wrapper);
    observer.observe(footer);
    const header = document.querySelector('#header-component');
    if (header) observer.observe(header);
  }

  footer.addEventListener('focusin', () => {
    if (!document.body.hasAttribute('data-shulin-footer-reveal')) return;
    if (main.getBoundingClientRect().bottom <= footer.getBoundingClientRect().top + 1) return;
    wrapper.scrollTo({ top: wrapper.scrollHeight - wrapper.clientHeight, behavior: 'instant' });
  });

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('pageshow', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('shopify:section:unload', scheduleUpdate);
  desktop.addEventListener('change', scheduleUpdate);
  reducedMotion.addEventListener('change', scheduleUpdate);
  scheduleUpdate();
})();
